import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/regenerator";
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import classNames from 'classnames';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { http } from '../../../services/http';
import { Icon, PageHeading } from '../../../subkit-ui';
import { currencySymbols } from '../../../utils/constants';
import { getPriceForAttendees, getPriceString } from '../../../utils/helpers';
import { bookingCreated, serviceCustomerCreated } from '../../../utils/segmentAnalytics';
import { stripeErrorHandler } from '../../../utils/stripe';
import { PriceSummary } from '../../PriceSummary';
import TWSessionInfo from '../../SessionLandingPage/TWSessionInfo/SessionInfo.container';
import TWServiceProfileLayout from '../../TWServiceProfileLayout/TWServiceProfileLayout.container';
import ExistingCardForm from '../ExistingCardForm.container';
import NewCardForm from '../NewCardForm.container';
import BookingConfirmationSummary from './ConfirmationSummary.container';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

/**
 * Primary UI component for user interaction
 */
export var OrderPage = function OrderPage(_ref) {
  var _session$price, _session$price$curren, _providerService$prov, _session$providerServ, _session$providerServ2, _session$providerServ3;

  var session = _ref.session,
      sessionAccess = _ref.sessionAccess,
      order = _ref.order,
      cardOnFile = _ref.cardOnFile,
      initOrderPayment = _ref.initOrderPayment,
      createBooking = _ref.createBooking,
      verifyPayment = _ref.verifyPayment,
      getServiceCustomersByUserIdAndServiceId = _ref.getServiceCustomersByUserIdAndServiceId;
  var router = useRouter();

  var _useState = useState(null),
      error = _useState[0],
      setError = _useState[1];

  var _useState2 = useState(false),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(false),
      existingServiceSubscription = _useState3[0],
      setExistingServiceSubscription = _useState3[1];

  var _useState4 = useState(false),
      forgetPaymentDetails = _useState4[0],
      setForgetPaymentDetails = _useState4[1];

  var price = session.price;
  var providerService = order.providerService; // TODO eventually we will use attendees as a line-item qty in the order
  // Updating the attendees will increase the qty on the order

  var attendees = 1;
  var currency = (session === null || session === void 0 ? void 0 : (_session$price = session.price) === null || _session$price === void 0 ? void 0 : (_session$price$curren = _session$price.currency) === null || _session$price$curren === void 0 ? void 0 : _session$price$curren.toLowerCase()) || 'usd';
  var isPaid = Boolean(price.unitAmount);
  var customerEntitled = !!(sessionAccess && sessionAccess.grantorType) || !isPaid;
  var totalPrice = order.grandTotalCents * attendees;
  var totalPriceString = getPriceString(totalPrice, currency);
  var priceBreakdown = getPriceForAttendees(totalPrice, attendees, currency);
  var totalSumString = customerEntitled ? "".concat(currencySymbols[currency], "0.00") : totalPriceString;
  var breadCrumbs = [{
    name: providerService === null || providerService === void 0 ? void 0 : providerService.name,
    pageName: 'Provider Service',
    url: "/".concat(providerService === null || providerService === void 0 ? void 0 : (_providerService$prov = providerService.provider) === null || _providerService$prov === void 0 ? void 0 : _providerService$prov.slug, "/").concat(providerService === null || providerService === void 0 ? void 0 : providerService.slug)
  }, {
    name: 'Book Session',
    pageName: 'Provider Service',
    url: (router === null || router === void 0 ? void 0 : router.asPath) || '#'
  }];
  var paymentDetails;

  if (order.paymentDetails) {
    paymentDetails = order.paymentDetails;
  } else if (cardOnFile) {
    paymentDetails = {
      paymentMethod: cardOnFile.id,
      type: cardOnFile.brand,
      last4: cardOnFile.last4
    };
  }

  var onCreateToken = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(receiveServiceEmails, token) {
      var initiatedOrder, serviceCustomerId;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return initOrderPayment({
                sessionId: session.id,
                orderId: order.id
              }, token);

            case 3:
              initiatedOrder = _context.sent;
              _context.next = 6;
              return getServiceCustomersByUserIdAndServiceId(order === null || order === void 0 ? void 0 : order.user.id, providerService.id);

            case 6:
              serviceCustomerId = _context.sent;
              serviceCustomerId && serviceCustomerCreated({
                user: serviceCustomerId,
                serviceId: providerService === null || providerService === void 0 ? void 0 : providerService.id,
                providerServices: providerService,
                serviceType: 'Session booking'
              });
              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              setError(_context.t0);
              return _context.abrupt("return");

            case 14:
              _context.prev = 14;
              _context.next = 17;
              return confirmPayment(initiatedOrder.paymentDetails);

            case 17:
              _context.next = 23;
              break;

            case 19:
              _context.prev = 19;
              _context.t1 = _context["catch"](14);
              setError(_context.t1);
              return _context.abrupt("return");

            case 23:
              _context.next = 25;
              return createBooking({
                serviceId: providerService.id,
                sessionId: session.id,
                orderId: initiatedOrder.id,
                attendees: 1,
                receiveServiceEmails: receiveServiceEmails
              }).then(function (booking) {
                var serviceId = providerService.id;
                booking && bookingCreated({
                  booking: booking,
                  serviceId: serviceId,
                  session: session,
                  providerService: providerService
                });
              });

            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10], [14, 19]]);
    }));

    return function onCreateToken(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  var confirmPayment = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(finalPaymentDetails) {
      var serviceStripe, result;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY, {
                stripeAccount: session.providerService.paymentPlatformId
              });

            case 2:
              serviceStripe = _context2.sent;
              _context2.next = 5;
              return serviceStripe.confirmCardPayment(finalPaymentDetails.clientSecret, {
                payment_method: finalPaymentDetails.paymentMethod
              });

            case 5:
              result = _context2.sent;

              if (result.error) {
                stripeErrorHandler(result.error);
              } // Poll the server to make sure stripe webhooks updated the order and marked it a success


              _context2.next = 9;
              return verifyPayment();

            case 9:
              return _context2.abrupt("return", result.paymentIntent);

            case 10:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function confirmPayment(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  var onConfirmPayment = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(receiveServiceEmails) {
      var initiatedOrder, serviceCustomerId;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;

              if (!order.paymentDetails) {
                _context3.next = 6;
                break;
              }

              _context3.next = 4;
              return confirmPayment(order.paymentDetails);

            case 4:
              _context3.next = 15;
              break;

            case 6:
              _context3.next = 8;
              return initOrderPayment({
                sessionId: session.id,
                orderId: order.id
              });

            case 8:
              initiatedOrder = _context3.sent;
              _context3.next = 11;
              return confirmPayment(initiatedOrder.paymentDetails);

            case 11:
              _context3.next = 13;
              return getServiceCustomersByUserIdAndServiceId(order === null || order === void 0 ? void 0 : order.user.id, providerService.id);

            case 13:
              serviceCustomerId = _context3.sent;
              serviceCustomerId && serviceCustomerCreated({
                user: serviceCustomerId,
                serviceId: providerService === null || providerService === void 0 ? void 0 : providerService.id,
                providerServices: providerService,
                serviceType: 'Session booking'
              });

            case 15:
              _context3.next = 17;
              return createBooking({
                serviceId: providerService.id,
                sessionId: session.id,
                orderId: order.id,
                attendees: attendees,
                receiveServiceEmails: receiveServiceEmails
              }).then(function (booking) {
                var serviceId = providerService.id;
                booking && bookingCreated({
                  booking: booking,
                  serviceId: serviceId,
                  session: session,
                  providerService: providerService
                });
              });

            case 17:
              return _context3.abrupt("return", true);

            case 20:
              _context3.prev = 20;
              _context3.t0 = _context3["catch"](0);
              setError(_context3.t0);
              return _context3.abrupt("return", false);

            case 24:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[0, 20]]);
    }));

    return function onConfirmPayment(_x4) {
      return _ref4.apply(this, arguments);
    };
  }();

  var onSubscriberConfirmation = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(receiveServiceEmails) {
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              setLoading(true);
              _context4.next = 4;
              return createBooking({
                serviceId: providerService.id,
                sessionId: session.id,
                orderId: order.id,
                attendees: attendees,
                receiveServiceEmails: receiveServiceEmails
              }).then(function (booking) {
                var serviceId = providerService.id;
                booking && bookingCreated({
                  booking: booking,
                  serviceId: serviceId,
                  session: session,
                  providerService: providerService
                });
              });

            case 4:
              setLoading(false);
              _context4.next = 12;
              break;

            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              setError(_context4.t0);
              setLoading(false);
              return _context4.abrupt("return");

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[0, 7]]);
    }));

    return function onSubscriberConfirmation(_x5) {
      return _ref5.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (sessionAccess !== null && sessionAccess !== void 0 && sessionAccess.serviceId) {
      http.get("provider-service/".concat(sessionAccess.serviceId, "/user-subscriptions")).then(function (response) {
        var _response$data;

        if (response !== null && response !== void 0 && (_response$data = response.data) !== null && _response$data !== void 0 && _response$data.id) setExistingServiceSubscription(true);
      });
    }
  }, [sessionAccess === null || sessionAccess === void 0 ? void 0 : sessionAccess.serviceId]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(TWServiceProfileLayout, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "max-w-full lg:max-w-screen-xl lg:mx-auto p-4",
        children: [/*#__PURE__*/_jsx("div", {
          className: "hidden md:block",
          children: /*#__PURE__*/_jsx(PageHeading, {
            pageTitle: "Book Session",
            breadCrumbs: breadCrumbs
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "sm:block md:hidden",
          children: /*#__PURE__*/_jsx(Link, {
            href: "/".concat((_session$providerServ = session.providerService) === null || _session$providerServ === void 0 ? void 0 : (_session$providerServ2 = _session$providerServ.provider) === null || _session$providerServ2 === void 0 ? void 0 : _session$providerServ2.slug),
            children: /*#__PURE__*/_jsxs("a", {
              className: "flex text-base font-medium no-underline text-gray-400",
              children: [/*#__PURE__*/_jsx(Icon, {
                name: "angle-left",
                type: "regular",
                className: "text-xl text-gray-400"
              }), /*#__PURE__*/_jsx("span", {
                className: "block ml-2  text-base font-medium text-gray-500 hover:text-gray-700",
                children: (_session$providerServ3 = session.providerService) === null || _session$providerServ3 === void 0 ? void 0 : _session$providerServ3.name
              })]
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex flex-col-reverse md:flex-row",
          children: [isPaid && /*#__PURE__*/_jsxs("div", {
            className: "mt-8 w-full md:mr-8 md:w-1/2",
            children: [!customerEntitled && (!error && paymentDetails && !forgetPaymentDetails ? /*#__PURE__*/_jsx(ExistingCardForm, {
              title: "Payment Method",
              serverError: error,
              paymentDetails: paymentDetails,
              providerService: providerService,
              serviceAccountId: providerService.paymentPlatformId,
              onConfirmPayment: onConfirmPayment,
              icon: order.grandTotalCents ? 'lock' : 'check',
              setForgetPaymentDetails: setForgetPaymentDetails
            }) : /*#__PURE__*/_jsx(NewCardForm, {
              serverError: error,
              providerService: providerService,
              serviceAccountId: providerService.paymentPlatformId,
              onCreateToken: onCreateToken,
              icon: order.grandTotalCents ? 'lock' : 'check'
            })), customerEntitled && /*#__PURE__*/_jsx("div", {
              className: "hidden md:block",
              children: /*#__PURE__*/_jsx(BookingConfirmationSummary, {
                providerService: providerService,
                isPaid: isPaid,
                onConfirmation: onSubscriberConfirmation,
                loading: loading,
                customerEntitled: customerEntitled,
                grantorType: sessionAccess === null || sessionAccess === void 0 ? void 0 : sessionAccess.grantorType,
                existingServiceSubscription: existingServiceSubscription
              })
            })]
          }), /*#__PURE__*/_jsxs("div", {
            className: classNames('mt-6 w-full md:w-3/5 lg:w-5/12', {
              'md:ml-2 md:-mt-8': isPaid
            }),
            children: [/*#__PURE__*/_jsx("div", {
              className: "mb-4",
              children: /*#__PURE__*/_jsx(TWSessionInfo, {
                session: session
              })
            }), isPaid && /*#__PURE__*/_jsxs("div", {
              className: "w-full text-base",
              children: [/*#__PURE__*/_jsx(PriceSummary, {
                description: priceBreakdown,
                price: totalPriceString,
                summaryClassNames: "text-neutral-400"
              }), /*#__PURE__*/_jsx(PriceSummary, {
                description: "Total (".concat(currency.toUpperCase(), ")"),
                price: totalSumString,
                dataCy: "total-cost",
                summaryClassNames: "font-medium"
              })]
            }), /*#__PURE__*/_jsx("div", {
              className: classNames({
                hidden: isPaid && !customerEntitled,
                'block md:hidden': isPaid && customerEntitled,
                block: !isPaid
              }),
              children: /*#__PURE__*/_jsx(BookingConfirmationSummary, {
                providerService: providerService,
                isPaid: isPaid,
                onConfirmation: onSubscriberConfirmation,
                loading: loading,
                customerEntitled: customerEntitled,
                grantorType: sessionAccess === null || sessionAccess === void 0 ? void 0 : sessionAccess.grantorType,
                existingServiceSubscription: existingServiceSubscription
              })
            })]
          })]
        })]
      })
    })
  });
};
export var Order = function Order(props) {
  // Initiate stripe on the Subkit level for the card form
  var stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_KEY);
  return /*#__PURE__*/_jsx(Elements, {
    stripe: stripePromise,
    children: /*#__PURE__*/_jsx(OrderPage, _objectSpread({}, props))
  });
};